var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipmentsList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 269 359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268,314c0-2.4-1.9-4.3-4.3-4.3H64.2c-2.4,0-4.3,1.9-4.3,4.3v10.2c0,13.9-11.3,25.2-25.2,25.2s-25.2-11.3-25.2-25.2V8.9h249.9v109.3c0,2.4,1.9,4.3,4.3,4.3s4.3-1.9,4.3-4.3V4.6c0-2.4-1.9-4.3-4.3-4.3H5.3C2.9.3,1,2.2,1,4.6v319.6c0,18.6,15.1,33.7,33.7,33.7h199.5c18.6,0,33.7-15.1,33.7-33.7v-10.2ZM259.4,324.2c0,13.9-11.3,25.2-25.2,25.2H57.2l1.7-1.7c6.2-6.3,9.6-14.7,9.6-23.5v-6h191v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.3,32.3H43.1c-2.4,0-4.3,1.9-4.3,4.3s1.9,4.3,4.3,4.3h187.2c2.4,0,4.3-1.9,4.3-4.3s-1.9-4.3-4.3-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.3,101.5H43.1c-2.4,0-4.3,1.9-4.3,4.3s1.9,4.3,4.3,4.3h147.2c2.4,0,4.3-1.9,4.3-4.3s-1.9-4.3-4.3-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.3,66.5H43.1c-2.4,0-4.3,1.9-4.3,4.3s1.9,4.3,4.3,4.3h187.2c2.4,0,4.3-1.9,4.3-4.3s-1.9-4.3-4.3-4.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.9,198.8v77.4c0,2,1.6,3.6,3.6,3.6h50.5c2,0,3.6-1.6,3.6-3.6v-77.4c0-2-1.6-3.6-3.6-3.6h-50.5c-2,0-3.6,1.6-3.6,3.6ZM56,272.7v-70.3h43.3v70.3h-43.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.5,181.4c0,2.8,2.5,5.1,5.6,5.1h39.2c3.1,0,5.6-2.3,5.6-5.1v-13.4c0-2.8-2.5-5.1-5.6-5.1h-39.2c-3.1,0-5.6,2.3-5.6,5.1v13.4ZM59.6,179.5v-9.4h36.1v9.4h-36.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.4,149.9c2,0,3.6-1.6,3.6-3.6v-2h25.3v2c0,2,1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.6v-5.6c0-2-1.6-3.6-3.6-3.6h-32.4c-2,0-3.6,1.6-3.6,3.6v5.6c0,2,1.6,3.6,3.6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.2,147c-.1-3.9-3.6-6.9-8-6.8h-6.4c-2,0-3.6,1.7-3.5,3.6,0,1,.4,1.9,1.1,2.5.7.7,1.6,1,2.5,1h6.5c.4,0,.7,0,.8.1l4.2,134.7c0,.5-.2,1-.6,1.4-.8.9-2.3,1.4-3.8,1.4H42.5c-1.5,0-3-.5-3.8-1.4-.4-.5-.7-.9-.6-1.4l4.2-134.7c.1,0,.4-.2.9-.2h6.4c.9,0,1.8-.3,2.5-1,.7-.7,1.1-1.6,1.1-2.5,0-2-1.6-3.6-3.5-3.6h-6.5c-4.3,0-7.8,2.9-8,6.8l-4.2,135c0,2.4.9,4.8,2.6,6.6,2.2,2.3,5.5,3.6,9,3.6h70.4c3.5,0,6.8-1.3,9-3.6,1.8-1.8,2.7-4.2,2.6-6.6l-4.2-135Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.7,141.9h-29.1c-1.8,0-3.3,1.5-3.3,3.3s1.5,3.3,3.3,3.3h27.1v133.9c0,1.7-1.4,3.2-3.2,3.2h-83.1c-1.9,0-3.5-1.5-3.5-3.5v-134c1.1-.6,1.8-1.7,1.8-3,0-1.8-1.5-3.3-3.3-3.3h-.2c-2.7,0-4.9,2.2-4.9,4.9v135.3c0,5.6,4.5,10.1,10.1,10.1h83.1c5.4,0,9.8-4.4,9.8-9.8v-135.9c0-2.5-2.1-4.6-4.6-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.3,191.1h39c2.7,0,4.9-2.2,4.9-4.9v-48.8h-48.4v49.1c0,2.5,2,4.5,4.5,4.5ZM174.4,144.1h35.1v40.3h-35.1v-40.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.3,268.6h28.8c2.7,0,4.9-2.2,4.9-4.9v-25.4c0-2.5-2-4.6-4.6-4.6h-29.2c-2.5,0-4.5,2-4.5,4.5v25.8c0,2.5,2,4.5,4.5,4.5ZM174.4,240.5h24.9v21.5h-24.9v-21.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentsList);
export default __webpack_public_path__ + "static/media/equipments_list.f295b7f1bc4b6e43d41ae6ff8322dd75.svg";
export { ForwardRef as ReactComponent };